export const SERVER_ADDRESS =
  process.env.REACT_APP_API_URL || "https://localhost:44382/api";
